export default __webpack_public_path__ + "media/images/preview-44f8cd8b.svg";